import { render, staticRenderFns } from "./addRoleForm.vue?vue&type=template&id=d56d4e00&scoped=true"
import script from "./addRoleForm.vue?vue&type=script&lang=js"
export * from "./addRoleForm.vue?vue&type=script&lang=js"
import style0 from "./addRoleForm.vue?vue&type=style&index=0&id=d56d4e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56d4e00",
  null
  
)

export default component.exports